import { Container, TableContainer, Paper, LinearProgress, Table, TableHead, TableRow, TableCell } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';

import logoSenior from '../../../assets/logo.png';

import IMedicalCertificate from '../../../interfaces/IMedicalCertificate';
import ViewTable from './ViewMedicalCerticateTable';
import IPage from '../../../interfaces/IPage';
import { WizardTitle } from '../components/WizardTitle';
import { WizardContent } from './ViewMedicalCertificate.styled';
import { useWizardRequest } from '../../../hooks/services/useWizardRequest';
import { useLocalStorage } from '../../../hooks/providers/useLocalStorage';
import { Img, WizardFooter } from '../../documentStatus/ConsultDocumentStats/ConsultProtocolDocument.styled';
import useWindowDimensions from '../../../hooks/util/useWindowDimensions';
import imgBack from '../../../assets/img-back.png';
import { Back } from '../wizard/Wizard.styles';
import { useNavigate } from 'react-router-dom';
import { useToastrVanila } from '../../../hooks/util/useToastrVanila';

interface FollowupListProps extends IPage {}

const ViewMedicalCertificate = ({ title }: FollowupListProps) => {
  const localStorage = useLocalStorage();
  const request = useWizardRequest();
  const navigate = useNavigate();

  const storage = localStorage.getItem('medicalCertificate');
  const employeeId = storage?.employeeId;
  const [isScreenSmall, setIsScreenSmall] = useState(false);
  const [toogleMenuPoint] = useState(550);
  const { width } = useWindowDimensions();

  const [medicalCertificates, setMedicalCertificates] = useState<IMedicalCertificate[]>([]);
  const [perPage] = useState(150);
  const [currentPage] = useState(1);
  const [orderDirection] = useState<'asc' | 'desc'>('desc');
  const [orderField] = useState<string>('createdAt');
  const [loading, setLoading] = useState(false);
  const toastr = useToastrVanila();
  const today = new Date();
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() - 60);
  useEffect(() => {
    if (width < toogleMenuPoint) {
      setIsScreenSmall(true);
    } else {
      setIsScreenSmall(false);
    }
  }, [width]);
  useEffect(() => {
    document.title = title;
  }, [title]);

  const listMedicalCertificates = useCallback(
    async (page = currentPage, limit = perPage, field = orderField, direction = orderDirection) => {
      if (!employeeId) return;

      setLoading(true);

      const query = `?perPage=${limit}&currentPage=${page}&orderField=${field}&orderDirection=${direction}`;
      const filters = {
        initialDate: futureDate.toISOString().split('T')[0],
        finalDate: today.toISOString().split('T')[0],
      };
      await request
        .listMedicalCertificate(employeeId, query, filters)
        .then(result => {
          setLoading(false);
          setMedicalCertificates(result.data);
        })
        .catch(() => {
          setLoading(false);
          toastr.error('Erro ao listar atestados médicos.');
        });
    },
    [employeeId, currentPage, perPage, orderField, orderDirection, request],
  );

  useEffect(() => {
    listMedicalCertificates();
  }, []);

  const headers = [
    { field: 'protocolNumber', label: 'Protocolo' },
    { field: 'createdAt', label: 'Data do Envio' },
    { field: 'documentDate', label: 'Data do Documento' },
    { field: 'timeQuantity', label: 'Tempo' },
    { field: 'diseaseClassification_code', label: 'CIDs' },
    { field: 'status', label: 'Situação' },
    { field: 'typeDocument_description', label: 'Tipo de documento' },
  ];

  const headersForMobile = [
    { field: 'actions', label: 'Ações' },
    { field: 'protocolNumber', label: 'Protocolo' },
    { field: 'createdAt', label: 'Data do Envio' },
  ];

  return (
    <>
      <Back onClick={() => navigate('/?step=3&employeeId=' + employeeId)}>
        <img src={imgBack} alt="voltar" />
      </Back>
      <Container sx={{ marginTop: 16, marginBottom: 6 }}>
        <WizardContent>
          <WizardTitle>Documentos enviados nos últimos 60 dias</WizardTitle>

          {loading && <LinearProgress />}

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                {isScreenSmall ? (
                  <TableRow>
                    {headersForMobile.map(header => (
                      <TableCell key={header.field}>{header.label}</TableCell>
                    ))}
                  </TableRow>
                ) : (
                  <TableRow>
                    {headers.map(header => (
                      <TableCell key={header.field}>{header.label}</TableCell>
                    ))}
                  </TableRow>
                )}
              </TableHead>

              {medicalCertificates.map(medicalCertificate => (
                <ViewTable
                  key={medicalCertificate.id}
                  smallScreen={isScreenSmall}
                  medicalCertificateRow={medicalCertificate}
                />
              ))}
            </Table>
          </TableContainer>
        </WizardContent>
      </Container>
      <WizardFooter style={{ marginBottom: '0px' }}>
        <>
          <Img src={logoSenior} alt="Senior" />
          Senior Norte PR
        </>
      </WizardFooter>
    </>
  );
};

export default ViewMedicalCertificate;
